<template>
  <b-overlay center :show="isLoading" rounded="sm">
    <div class="table-container mb-5" v-if="canVerb(resource, 'index')">
      <importer-form
        :config="config"
        :is-loading="isLoading"
        @upload="uploadFile"
        @delete="deleteFile"
        @init="startTransmission"
      ></importer-form>
    </div>
    <div v-else class="mt-3">
      <b-icon icon="info-circle" scale="1.00"></b-icon>
      Non hai i permessi
    </div>
    <template #overlay>
      <div class="text-center">
        <div class="custom-loader"></div>
        <p class="loading-text">Operazione in corso...</p>
      </div>
    </template>
  </b-overlay>
</template>

<script>
import { canVerb } from "@/utils/permissions";
import ImporterForm from "@/components/form/ImporterForm";
import ImporterMixin from "@/mixins/ImporterMixin";

export default {
  mixins: [ImporterMixin],
  name: "Importer",
  data() {
    return {
      resource: "importers",
      reposiotry: "importer",
      isLoading: false,
      config: [],
    };
  },
  props: {
    importer: {
      default() {
        return {};
      },
      type: Object,
    },
  },
  methods: {
    canVerb,
  },
  components: {
    ImporterForm,
  },
  created() {
    this.fetch();
  },
};
</script>
